(function () {
  'use strict';

  angular.module('app').component('paymentMethodsPage', paymentMethodListCrtl());

  function paymentMethodListCrtl() {
    return {
      bindings: {},
      controller: PaymentMethodListCrtl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/payment-methods/payment-methods-page.component.html',
    };
  }

  PaymentMethodListCrtl.$inject = [
    'UtilService',
    'AbilityService',
    'PaymentMethodService',
    'LanguageService',
  ];

  function PaymentMethodListCrtl(
    UtilService,
    AbilityService,
    PaymentMethodService,
    LanguageService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_paymentmethod_accountadmin'),
    };

    // Methods
    vm.createPaymentMethod = createPaymentMethod;
    vm.onShowPaymentMethod = onShowPaymentMethod;

    // Initializers
    getAdditionalLanguages();

    function getPaymentMethods(selectedItem) {
      vm.filterCriteria = PaymentMethodService.getFilterCriteria();
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      PaymentMethodService.getPaymentMethods(vm.filterCriteria).then(function (data) {
        vm.paymentMethods = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        if (selectedItem) {
          vm.UtilService.itemListChanged(selectedItem.id);
        }
      });
    }

    function getAdditionalLanguages() {
      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        let languages = data.items;

        vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
        vm.additionalLanguages = languages.filter((language) => !language.is_default);

        getPaymentMethods('');
      });
    }

    function createPaymentMethod() {
      if (!vm.permissions.canCreate) {
        return;
      }

      PaymentMethodService.openPaymentMethodModal(
        {},
        vm.defaultLanguage,
        vm.additionalLanguages,
        'create',
        getPaymentMethods
      );
    }

    function onShowPaymentMethod(PaymentMethod, mode) {
      PaymentMethodService.openPaymentMethodModal(
        PaymentMethod,
        vm.defaultLanguage,
        vm.additionalLanguages,
        mode
      );
    }
  }
})();
